"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.handleLoginSysMessage = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _RegisterInstance = _interopRequireDefault(require("../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../utils/HttpRequest");

var _BuildConstants = require("../utils/BuildConstants");

var _MuiAlertHelper = require("./MuiAlertHelper");

var _strings = require("../../config/strings");

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _Feature = _interopRequireDefault(require("../utils/features/Feature"));

var _FeatureManager = _interopRequireDefault(require("../utils/features/FeatureManager"));

var _ErrorHelper = require("./ErrorHelper");

var _NavigationManagerCordova = _interopRequireDefault(require("../common/NavigationManagerCordova"));

var handleLoginSysMessage = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
    var authToken, token, response, data, feature, showLoginSuccessful;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _RegisterInstance["default"].getAccessToken('authUser:register');

          case 3:
            authToken = _context.sent;
            token = message.actionParams.token;
            _context.next = 7;
            return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.AUTH_HOST, "/rest/api/v1/backAuth/revalidateUser"), {
              oneTimeToken: token
            }, {}, false, 10000, null, 'Bearer ' + authToken);

          case 7:
            response = _context.sent;
            data = response.data;
            console.log('revalidateUser', response);

            if (!data.success) {
              (0, _MuiAlertHelper.showAlertWithOptions)({
                title: (0, _strings.getString)('ERROR'),
                message: (0, _strings.getString)('E_MUST_REVALIDATE')
              });
            }

            _context.next = 13;
            return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true);

          case 13:
            _context.next = 15;
            return _DataStore["default"].loadFromServer(_DataStore.DATA_STORE_PATHS.PUBLIC);

          case 15:
            feature = new _Feature["default"](data.features ? data.features.join(',') : undefined, data.activationCode ? data.activationCode : null, data.user && data.user.username ? data.user.username : null, null, null);
            _context.next = 18;
            return _FeatureManager["default"].saveFeature(feature);

          case 18:
            showLoginSuccessful = function showLoginSuccessful() {
              var okButton = {
                label: (0, _strings.getString)('OK'),
                callback: function callback() {
                  return _NavigationManagerCordova["default"].goHome();
                }
              };
              (0, _MuiAlertHelper.showAlertWithOptions)({
                title: (0, _strings.getString)('LOGIN_SUCCESSFUL_TITLE'),
                message: (0, _strings.getString)('LOGIN_SUCCESSFUL_MESSAGE'),
                buttons: [okButton],
                showCloseButton: false
              });
            };

            showLoginSuccessful();
            return _context.abrupt("return", true);

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](0);
            console.log('error automatic qd login', _context.t0);
            (0, _MuiAlertHelper.showAlertWithOptions)({
              title: (0, _strings.getString)('ERROR'),
              message: (0, _ErrorHelper.getErrorMessage)(_context.t0)
            });

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 23]]);
  }));

  return function handleLoginSysMessage(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.handleLoginSysMessage = handleLoginSysMessage;